import React from 'react'

const ActionPopup = ({handleClose, onEdit}) => {
  const onClose = (e) => {
    e.preventDefault()
    e.stopPropagation()

    if(typeof handleClose === 'function'){
      handleClose(false)
    }
  }

  return (
    <div
      className="fixed left-0 top-0 w-full h-screen flex justify-center items-center overflow-y-auto"
      style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
      onClick={onClose}
    >
      <div className="absolute bottom-0 left-0 w-full p-5">
        <div onClick={onClose}>
          <div className="rounded bg-white mb-4">
            <div className="border-b text-center" onClick={onEdit}>
              <p className="py-3 text-sm underline">Edit</p>
            </div>
            <div className="text-center">
              <p className="py-3 text-sm underline text-gray-999">Delete</p>
            </div>
          </div>
          <div className="rounded bg-white text-center" onClick={onClose}>
            <p className="py-3 text-sm underline">Cancel</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ActionPopup }